import axiosInstance from './axiosInstance';

const addCard = async ({user, score, word, definition, token}) => {
  try {
    const response = await axiosInstance.post(
      '/cards/add',
      {
        user_id: user,
        user_score: score,
        word: word,
        definition: definition
      },
      {
        headers: {
          Authorization: token,
        },
      });
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {addCard};